import { Shield, FileText, Users, Briefcase, BarChart3, FolderOpen, TrendingUp, MessageSquare, Activity, Bell, ShieldAlert, Mail, Building2, Rss, LayoutDashboard, Flag, Send, ShieldCheck, MapPin, Target, Rocket, Link2, History, Download, Zap, LineChart, Flame, RotateCcw, Database, Crown, FileUp, Megaphone, MailQuestion, Sparkles, Bot, Workflow, Wallet } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar";

const adminItems = [
  { title: "Dashboard", url: "/admin", icon: BarChart3 },
  { title: "Data Room", url: "/admin/data-room", icon: Database },
  { title: "Ads data", url: "/admin/ads-data", icon: LineChart },
  { title: "Sprint 1 Validatie", url: "/admin/validation", icon: TrendingUp },
  { title: "Live Dashboard", url: "/admin/live-dashboard", icon: Activity },
  { title: "Analytics Funnel", url: "/admin/analytics-funnel", icon: TrendingUp },
  { title: "Landing Signups", url: "/admin/landing-signups", icon: Rocket },
  { title: "Alert Settings", url: "/admin/alert-settings", icon: Bell },
  { title: "Feature Flags", url: "/admin/feature-flags", icon: Flag },
  { title: "Dashboard Tiles", url: "/admin/dashboard-tiles", icon: LayoutDashboard },
  { title: "Performance", url: "/admin/performance", icon: TrendingUp },
  { title: "Data Breaches", url: "/admin/breach-management", icon: ShieldAlert },
  { title: "Bedrijven Onboarding", url: "/admin/company-onboarding", icon: Shield },
  { title: "Onboarding Emails", url: "/admin/onboarding-emails", icon: Rocket },
  { title: "CV Control", url: "/admin/cv-control", icon: FileUp },
  { title: "Partner Marketing", url: "/admin/partner-marketing", icon: Megaphone },
  { title: "Boost Workflow", url: "/admin/boost-workflow", icon: Workflow },
  { title: "Vacature Boosts", url: "/admin/vacature-boosts", icon: Zap },
  { title: "Boost Credits (oud)", url: "/admin/boost-credits", icon: Zap },
  { title: "Boost Analytics", url: "/admin/boost-analytics", icon: LineChart },
  { title: "Gebruikers", url: "/admin/users", icon: Users },
  { title: "Admin Rollen", url: "/admin/role-management", icon: ShieldCheck },
  { title: "Bedrijven", url: "/admin/companies", icon: Building2 },
  { title: "Premium Beheer", url: "/admin/premium", icon: Crown },
  { title: "Wallet Tegoed", url: "/admin/wallet-credits", icon: Wallet },
  { title: "AI Recruiter toegang", url: "/admin/ai-recruiter-access", icon: Sparkles },
  { title: "AI Recruiters actief", url: "/admin/ai-recruiters-actief", icon: Bot },
  { title: "Vacatures", url: "/admin/jobs", icon: Briefcase },
  { title: "Vacatures Homepage", url: "/admin/homepage-jobs", icon: LayoutDashboard },
  { title: "Import Aanvragen", url: "/admin/job-import-requests", icon: Download },
  { title: "Actieve Koppelingen", url: "/admin/job-sources", icon: Link2 },
  { title: "Import Logs", url: "/admin/job-import-logs", icon: History },
  { title: "Job Alerts", url: "/admin/job-alerts", icon: Bell },
  { title: "Email Templates", url: "/admin/email-templates", icon: Mail },
  { title: "Mailings", url: "/admin/mailings", icon: Send },
  { title: "Vacature Allocatie", url: "/admin/vacature-allocatie", icon: Sparkles },
  { title: "Luna Runs", url: "/admin/luna-runs", icon: Target },
  { title: "AI Recruiter Runs", url: "/admin/ai-recruiter-runs", icon: Bot },
  { title: "AI Score Calibratie", url: "/admin/ai-recruiter-calibratie", icon: Target },
  { title: "Reset Funnel", url: "/admin/password-reset-funnel", icon: ShieldCheck },
  { title: "AI Consent", url: "/admin/consent", icon: ShieldCheck },
  { title: "Social Media", url: "/admin/social-media", icon: Rss },
  { title: "Blog Artikelen", url: "/admin/blogs", icon: FileText },
  { title: "Categorieën", url: "/admin/categories", icon: FolderOpen },
  { title: "Blog Analytics", url: "/admin/analytics", icon: TrendingUp },
  { title: "SEO Center", url: "/admin/seo", icon: Target },
  { title: "Customer Success", url: "/admin/support", icon: MessageSquare },
  { title: "Open Berichten", url: "/admin/pending-messages", icon: MailQuestion },
  { title: "Team Berichten", url: "/admin/team-berichten", icon: Send },
  { title: "Boiler Room", url: "/admin/boiler-room", icon: Flame },
  { title: "Data Bescherming", url: "/admin/data-protection", icon: Database },
  { title: "Profile Recovery", url: "/admin/profile-recovery", icon: RotateCcw },
  { title: "Bedrijven Updates", url: "/admin/company-updates", icon: Megaphone },
  { title: "Interne Vacatures", url: "/admin/careers", icon: Briefcase },
];
export function AdminSidebar() {
  const { open } = useSidebar();
  const { isEnabled: suggestionsEnabled } = useFeatureFlag('platform_suggestions');

  const visibleItems = adminItems.filter(item =>
    item.title !== "Vacature Allocatie" || suggestionsEnabled
  );

  return (
    <Sidebar className={open ? "w-60" : "w-14"} collapsible="icon">
      <div className="p-4 border-b">
        <div className="flex items-center gap-2">
          <Shield className="w-6 h-6 text-primary" />
          {open && <span className="font-heading font-black text-lg">Admin Panel</span>}
        </div>
      </div>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Beheer</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {visibleItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      end
                      className="hover:bg-muted/50"
                      activeClassName="bg-muted text-primary font-medium"
                    >
                      <item.icon className="w-4 h-4" />
                      {open && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
